import { render, staticRenderFns } from "./MySetFatePanel.vue?vue&type=template&id=601f3e9e&"
import script from "./MySetFatePanel.vue?vue&type=script&lang=js&"
export * from "./MySetFatePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports